import { useEffect, useState } from "react";
import { Users, MessageSquare, ListTodo, Building2, Search } from "lucide-react";

const BASE = import.meta.env.BASE_URL;

export default function BankerInvestors() {
  const [investors, setInvestors] = useState<any[]>([]);
  const [selected, setSelected] = useState<any | null>(null);
  const [chats, setChats] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("banker_token");
    if (!token) return;
    (async () => {
      try {
        const r = await fetch(`${BASE}api/banker/investors`, { headers: { "x-banker-token": token } });
        if (r.ok) setInvestors(await r.json());
      } catch {}
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!selected) { setChats([]); return; }
    const token = localStorage.getItem("banker_token");
    if (!token) return;
    (async () => {
      try {
        const r = await fetch(`${BASE}api/banker/investors/${selected.id}/chats`, { headers: { "x-banker-token": token } });
        if (r.ok) setChats(await r.json());
      } catch {}
    })();
  }, [selected]);

  const filtered = investors.filter(i => !q || i.name.toLowerCase().includes(q.toLowerCase()) || (i.firm || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-5">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-3xl font-bold flex items-center gap-2"><Users className="w-7 h-7 text-[#FF5C00]" /> Investors on my portcos</h1>
          <p className="text-white/50 text-sm mt-1">Investors holding a stake in companies you cover. Click any to see their full Kavya history.</p>
        </div>
      </div>

      <div className="relative max-w-md">
        <Search className="w-4 h-4 text-white/40 absolute left-3 top-1/2 -translate-y-1/2" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search investors..."
          className="w-full bg-white/[0.04] border border-white/[0.1] rounded-lg pl-9 pr-3 py-2 text-sm placeholder-white/30 focus:outline-none focus:border-[#FF5C00]/40" />
      </div>

      {loading ? (
        <div className="space-y-2">{[...Array(3)].map((_, i) => <div key={i} className="h-20 bg-white/[0.04] rounded-lg animate-pulse" />)}</div>
      ) : filtered.length === 0 ? (
        <div className="bg-white/[0.04] border border-white/[0.1] rounded-xl p-12 text-center">
          <p className="text-white/40 text-sm">{investors.length === 0 ? "No investors in your portfolio yet — they'll appear here automatically once someone invests in a company you cover." : "No matches."}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-1 space-y-2">
            {filtered.map(inv => (
              <button key={inv.id} onClick={() => setSelected(inv)}
                className={`w-full text-left bg-white/[0.04] hover:bg-white/[0.06] border rounded-xl p-4 transition-colors ${selected?.id === inv.id ? "border-[#FF5C00]/50" : "border-white/[0.08]"}`}>
                <p className="font-medium text-white">{inv.name}</p>
                {inv.firm && <p className="text-white/50 text-xs">{inv.firm}</p>}
                {inv.viaCompanies?.length > 0 && (
                  <p className="text-[10px] text-white/50 mt-1.5 leading-snug">
                    via <span className="text-[#FF5C00]">{inv.viaCompanies.map((c: any) => c.name).join(", ")}</span>
                  </p>
                )}
                <div className="flex items-center gap-3 mt-2 text-[10px] text-white/40 font-mono">
                  <span className="flex items-center gap-1"><MessageSquare className="w-3 h-3" /> {inv.chatMessages}</span>
                  <span className="flex items-center gap-1"><ListTodo className="w-3 h-3" /> {inv.openTasks} open</span>
                </div>
              </button>
            ))}
          </div>

          <div className="md:col-span-2 bg-white/[0.04] border border-white/[0.1] rounded-xl p-5 min-h-[400px]">
            {!selected ? (
              <div className="text-center py-16 text-white/40 text-sm">Select an investor to see their Kavya conversation history.</div>
            ) : (
              <>
                <div className="pb-4 border-b border-white/[0.08] mb-4">
                  <p className="font-bold text-white">{selected.name}</p>
                  <p className="text-white/50 text-xs">{selected.email}{selected.phone ? ` · ${selected.phone}` : ""}</p>
                </div>
                {chats.length === 0 ? (
                  <p className="text-white/40 text-sm text-center py-8">No Kavya conversations yet.</p>
                ) : (
                  <div className="space-y-3 max-h-[500px] overflow-y-auto">
                    {chats.map((m: any) => (
                      <div key={m.id} className={`rounded-lg p-3 text-sm ${m.role === "user" ? "bg-[#FF5C00]/10 border border-[#FF5C00]/20 text-white/90" : "bg-white/[0.03] border border-white/[0.08] text-white/80"}`}>
                        <p className="text-[10px] uppercase tracking-wider text-white/40 font-mono mb-1">{m.role === "user" ? selected.name.split(" ")[0] : "Kavya"} · {new Date(m.createdAt).toLocaleString()}</p>
                        <p className="whitespace-pre-wrap leading-relaxed">{m.content.replace(/\[OPTIONS:[^\]]*\]/g, "").trim()}</p>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
